import { all, call, put, takeEvery } from 'redux-saga/effects';
import { APIClient, setAuthorization } from '../../helpers/apiClient';
import { getAccessToken } from '../../helpers/user';
import {
  FILTER_QUESTIONS_REQUEST,
  GET_QUESTIONS_DETAIL_REQUEST,
  GET_QUESTIONS_REQUEST,
  QUESTIONS_FAVORITE_REQUEST,
  QUESTIONS_UNLOCK_REQUEST,
} from './constants';

import * as actions from './actions';

const get = new APIClient().get;
const post = new APIClient().create;
const update = new APIClient().update;

function* getQuestionsRequest({ payload }) {
  try {
    setAuthorization(getAccessToken());
    const response = yield call(get, 'api/questions', {
      params: payload,
    });
    if (payload.related_id) {
      response.is_related = true;
    }
    yield put(actions.getQuestionsSuccess(response));
  } catch (error) {}
}

function* getQuestionDetailRequest({ payload }) {
  try {
    setAuthorization(getAccessToken());
    const response = yield call(get, 'api/questions/' + payload);
    yield put(actions.getQuestionDetailSuccess(response.data));
  } catch (error) {}
}

function* filterQuestionsRequest(action) {
  const data = action.payload;
  const formData = new FormData();
  try {
    if (data?.order_by) {
      formData.append('order_by', data.order_by);
    }
    if (data?.topic_id) {
      formData.append('topic_id', data.topic_id);
    }
    if (data?.is_free !== null) {
      formData.append('is_free', data.is_free);
    }
    if (data?.label_ids.length) {
      formData.append('is_free', data.is_free);
    }
    formData.append('name', 'abc');
    const res = yield call(post, '/api/questions', formData);
    console.log('saga', res);
    yield put(actions.filterQuestionsSuccess(res.data));
  } catch (error) {
    yield put(actions.filterQuestionsFailed(error));
  }
}

function* questionUnlockRequest({ payload, callback }) {
  try {
    setAuthorization(getAccessToken());
    const response = yield call(update, 'api/questions/' + payload + '/unlock');

    callback(response.data.status);
  } catch (error) {
    callback(false);
  }
}

function* questionFavoriteRequest({ payload, callback }) {
  try {
    setAuthorization(getAccessToken());
    yield call(post, 'api/users/question', payload);

    callback && callback(true);
  } catch (error) {
    callback && callback(false);
  }
}

export default function* questionsSaga() {
  yield all([
    takeEvery(GET_QUESTIONS_REQUEST, getQuestionsRequest),
    takeEvery(GET_QUESTIONS_DETAIL_REQUEST, getQuestionDetailRequest),
    takeEvery(FILTER_QUESTIONS_REQUEST, filterQuestionsRequest),
    takeEvery(QUESTIONS_UNLOCK_REQUEST, questionUnlockRequest),
    takeEvery(QUESTIONS_FAVORITE_REQUEST, questionFavoriteRequest),
  ]);
}
